import Drawer from "../../../../drawer/Drawer";
import ManageTax from "../ManageTax";

const ManageTaxDrawer = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl"}
      size={"xl2"}
      title={data?._id ? "Update Tax" : "Add Tax"}
      subtitle="View, update and modify user details and information bellow"
      drawerBodyClass="p-0 max-h-[calc(100%-42px)]"
    >
      <ManageTax getResponse={getResponse} close={close} data={data} />
    </Drawer>
  );
};

export default ManageTaxDrawer;
